document.addEventListener('DOMContentLoaded', () => {
	const roleSelect = document.getElementById('user_role_ids');
	if (roleSelect) {
		new TomSelect(roleSelect);
	}
});
